module.exports = __webpack_public_path__ + "img/img11.ba47d8bc.jpg";